export default __webpack_public_path__ + "static/media/TAB-staff.4431ff82.png";